<template>
  <v-select
    v-model="selected"
    :options="options"
    :label="labelField"
    :input-id="inputId"
    :placeholder="placeholder"
    :multiple="multiple"
    @input="$emit('change', selected)"
  >
    <span slot="no-options">{{ noOptionsText }}</span>
  </v-select>
</template>

<script>

import vSelect from 'vue-select'
import { ref, watch } from 'vue'

export default {
  name: 'VSelectField',
  components: {
    vSelect
  },
  emits: ['change'],
  props: {
    options: {
      type: Array,
      required: true,
    },
    inputId: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: true,
    },
    noOptionsText: {
      type: String,
      required: true,
    },
    value: {
      type: [Object, Array, null],
      required: false,
    },
    multiple: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    labelField: {
      type: String,
      required: false,
      default: () => 'label',
    },
  },
  setup(props) {
    const selected = ref(null)

    selected.value = props.value

    watch(() => props.value, () => selected.value = props.value)

    return {
      selected,
    }
  }
}
</script>
